import { render, staticRenderFns } from "./popupInfo.vue?vue&type=template&id=5ccae4ba&scoped=true"
import script from "./popupInfo.vue?vue&type=script&lang=js"
export * from "./popupInfo.vue?vue&type=script&lang=js"
import style0 from "./popupInfo.vue?vue&type=style&index=0&id=5ccae4ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccae4ba",
  null
  
)

export default component.exports